export const IS_PROD = process.env.REACT_APP_ENV === 'production';
export const IS_DEV = process.env.REACT_APP_ENV === 'development';
